import { profile, travel, axiosConfig } from 'api';

import { Company } from 'models/company';
import { PaymentMethodResponseData, PaymentMethod, PaymentCardData, PaymentCard } from 'models/paymentCard';
import { Response } from 'models/response';

// export const getGroupPaymentMethods = async (groupId: string): Promise<PaymentMethod[]> => {
//   try {
//     const response = await profile.get<Response<PaymentMethodResponseData>>(
//       `/Payments/UserGroup/${groupId}/Payments`,
//       axiosConfig,
//     );
//     return response.data.data.payment_methods;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// };

export const getPaymentMethods = async (): Promise<PaymentMethod[]> => paymentMethods;

const paymentMethods: PaymentMethod[] = [
  {
    id: 'cc',
    type: 'true',
    description: 'Crédito o Débito (Con CVV)',
    main_description: 'Crédito o Débito (Con CVV)',
    icon: 'https://images.rappi.com/payment_methods/cc_round.png',
    main_icon: 'https://images.rappi.com/payment_methods/cc_round.png',
    available: true,
    default: false,
    recommended: true,
    metadata: {
      billing_agreement: false,
    },
    flow_type: 'CC_STEP_BY_STEP',
    tokenizer: 'TOKENEX',
  },
  {
    id: 'american_express',
    type: 'true',
    description: 'Amex',
    main_description: 'Amex',
    icon: 'https://images.rappi.com/payment_methods/amex_round_100_2.png',
    main_icon: 'https://images.rappi.com/payment_methods/amex_round_100_2.png',
    available: true,
    default: false,
    recommended: true,
    metadata: {
      billing_agreement: false,
    },
    flow_type: 'CC_STEP_BY_STEP',
    tokenizer: 'TOKENEX',
  },
  {
    id: 'diners',
    type: 'true',
    description: 'Diners Club',
    main_description: 'Diners Club',
    icon: 'https://images.rappi.com/payment_methods/diners_round_100.png',
    main_icon: 'https://images.rappi.com/payment_methods/diners_round_100.png',
    available: true,
    default: false,
    recommended: true,
    metadata: {
      billing_agreement: false,
    },
    flow_type: 'CC_STEP_BY_STEP',
    tokenizer: 'TOKENEX',
  },
  {
    id: 'master',
    type: 'true',
    description: 'Mastercard',
    main_description: 'Mastercard',
    icon: 'https://images.rappi.com/payment_methods/master_round_100_2.png',
    main_icon: 'https://images.rappi.com/payment_methods/master_round_100_2.png',
    available: true,
    default: false,
    recommended: true,
    metadata: {
      billing_agreement: false,
    },
    flow_type: 'CC_STEP_BY_STEP',
    tokenizer: 'TOKENEX',
  },
  {
    id: 'visa',
    type: 'true',
    description: 'Visa',
    main_description: 'Visa',
    icon: 'https://images.rappi.com/payment_methods/visa_round_100_2.png',
    main_icon: 'https://images.rappi.com/payment_methods/visa_round_100_2.png',
    available: true,
    default: false,
    recommended: true,
    metadata: {
      billing_agreement: false,
    },
    flow_type: 'CC_STEP_BY_STEP',
    tokenizer: 'TOKENEX',
  },
];

interface ISpreedlyData {
  spreedly_data: {
    credit_card_data: ISpreedlyCreditCardData;
    tokenizer: string;
    email: string;
    document: IDocument;
  };
}

interface ISpreedlyCreditCardData {
  payment_method_token: string;
  is_debit: boolean;
}

interface IVGSData {
  vgs_data: {
    credit_card_data: IVGSCreditCardData;
    tokenizer: string;
    email: string;
    document: IDocument;
  };
}

interface IVGSCreditCardData {
  card_cvv: string;
  card_number: string;
  first_six_digits: string;
  last_four_digits: string;
  email: string;
  first_name: string;
  last_name: string;
  month: string;
  year: string;
  is_debit: true;
}

interface IDocument {
  document_value: string;
  document_type_id: string;
}

type IResponse = ISpreedlyResponse | IVGSResponse;

const paymentIsVGS = (payment: IResponse) => payment.tokenizer.toUpperCase() === 'VGS';

const formatPayment = (payment: IResponse, email: string, document: string) => {
  const doc = {
    document_value: document,
    document_type_id: '',
  };
  if (paymentIsVGS(payment)) {
    return {
      vgs_data: {
        credit_card_data: payment.credit_card_data as IVGSCreditCardData,
        tokenizer: payment.tokenizer,
        email: email,
        document: doc,
      },
    } as IVGSData;
  }
  return {
    spreedly_data: {
      credit_card_data: payment.credit_card_data as ISpreedlyCreditCardData,
      tokenizer: payment.tokenizer,
      email: email,
      document: doc,
    },
  } as ISpreedlyData;
};

interface ISpreedlyResponse {
  credit_card_data: ISpreedlyCreditCardData;
  tokenizer: string;
}

interface IVGSResponse {
  credit_card_data: IVGSCreditCardData;
  tokenizer: string;
}

export const addPaymentCard = async (
  payment: IResponse,
  email: string,
  document: string,
  groupId?: string,
): Promise<any> => {
  const data = formatPayment(payment, email, document);
  try {
    let serviceReq = '/Payments/Company/Cards';
    if (groupId) {
      serviceReq = `/Payments/UserGroup/${groupId}/Cards`;
    }
    const response = await profile.post<Response<any>>(serviceReq, data, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const changeDefaultCard = async (cardId: string): Promise<any> => {
  try {
    const response = await profile.put<Response<any>>(
      '/Payments/Company/Cards/Default',
      { CardId: cardId },
      axiosConfig,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getGroupAllPaymentCards = async (groupId: string): Promise<PaymentCard[]> => {
  try {
    const response = await profile.get<Response<PaymentMethodResponseData>>(
      `/Payments/UserGroup/${groupId}/Cards`,
      axiosConfig,
    );
    const { cards } = response.data.data;
    if (cards && cards.length > 0) return cards;
    return [];
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAllPaymentCards = async (): Promise<PaymentCardData[]> => {
  try {
    const response = await profile.get<Response<PaymentCardData[]>>('Payments/Company/Cards', axiosConfig);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAllPaymentCardsByUserId = async (userId: string): Promise<PaymentCardData[]> => {
  try {
    const andUserId = `?userId=${userId}`;
    
    const response = await profile.get<Response<PaymentCardData[]>>(`Payments/Company/Cards${andUserId}`, axiosConfig);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveGroupsCard = async (cardId: string, groups: string[]): Promise<Response<any>> => {
  try {
    const response = await profile.put<Response<PaymentMethodResponseData>>(
      '/Payments/Company/Cards/Groups',
      { CardId: cardId, GroupsIds: groups },
      axiosConfig,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const removeGroupsCard = async (cardId: string, groupsId: string[]): Promise<Response<any>> => {
  try {
    const response = await profile.delete<Response<PaymentMethodResponseData>>('/Payments/Company/Cards/Groups', {
      data: { CardId: cardId, GroupsIds: groupsId },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const removeCard = async (cardId: string): Promise<Response<any>> => {
  try {
    const response = await profile.delete<Response<PaymentMethodResponseData>>(
      `/Payments/Company/Cards/${cardId}`,
      axiosConfig,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTravelStatus = async (travelId: string): Promise<Response<any>> => {
  try {
    const response = await travel.get<Response<any>>(`/PaymentExecution/Travel/${travelId}`, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getCompanyLineCredit = async (companyId: string): Promise<Response<Company>> => {
  try {
    const response = await profile.get<Response<Company>>(`/Company/${companyId}`, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const addCreditCard = async (
  tokenexCCNumber: string,
  cardHolderFirstName: string,
  cardHolderLastName: string,
  emailHolder: string,
  expirationDate: string,
  userId: string,
  companyId: string,
  associate: string,
  groupId?: string,
  last4Digits?: string,
  bin?: string,
  alias?: string,
): Promise<any> => {
  try {
    const data = {
      tokenexCCNumber: tokenexCCNumber,
      cardHolderFirstName: cardHolderFirstName,
      cardHolderLastName: cardHolderLastName,
      emailHolder: emailHolder,
      expirationDate: expirationDate,
      last4Digits: last4Digits,
      bin: bin,
      associate: associate,
      alias: alias,
      userId: userId,
      companyId: companyId,
      groupId: groupId,
    };

    let serviceReq = '/Payments/Company/Cards';
    if (groupId) {
      serviceReq = `/Payments/UserGroup/${groupId}/Cards`;
    }

    const response = await profile.post<Response<any>>(serviceReq, data, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTokenexAuthenticationKey = async () => {
  try {
    const response = await profile.get<Response<any>>('/Payments/IframeConfiguration', axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
